<template>
  <dialog-base show-close @close="close">
    <img class="mod-map" :src="require('../../../assets/dialog/dialog-share-map.jpg')" alt="">
  </dialog-base>
</template>

<script>

import DialogBase from '../base'
import mixin from '../mixin'
export default {
  mixins: [mixin],
  components: {
    DialogBase
  },
  data() {
    return {
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.mod-map {
  width: 100%;
  height: auto;
  object-fit: contain;
}
</style>